import React, { useState } from "react";
import { ReceiptItem } from "./models/printer";
import { PrinterService } from "./printer.service";
import { Button } from "@/components/ui/button";
import { OrderModel } from "../orders/models/order.model";
import { Printer } from "lucide-react";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

interface OrderPrinterProps {
  order: OrderModel | null | undefined;
}

const OrderPrinterComponent: React.FC<OrderPrinterProps> = ({ order }) => {
  const [writer, setWriter] = useState<PrinterWriter | null>(null);
  const [status, setStatus] = useState<string>("Disconnected");

  const handleConnect = async (): Promise<void> => {
    try {
      setStatus("Connecting...");
      const printerWriter = await PrinterService.connectSerial();
      if (printerWriter) {
        setWriter(printerWriter);
        setStatus("Connected");
      } else {
        setStatus("Connection failed");
      }
    } catch (error) {
      console.error("Connect error:", error);
      setStatus("Connection failed");
    }
  };

  const handleDisconnect = async (): Promise<void> => {
    try {
      setStatus("Disconnecting...");
      await PrinterService.disconnectSerial();

      setWriter(null);
      setStatus("Disconnected");
    } catch (error) {
      console.error("Disconnect error:", error);
      setStatus("Disconnection failed");
    }
  };

  const handlePrint = async (): Promise<void> => {
    if (!writer) return;

    setStatus("Printing...");
    try {
      await PrinterService.printOrderReceipt(writer, order);
      // await PrinterService.printReceipt(writer,[{name:"test",price:100}]);
      toast.success("Print completed");
      setStatus("Connected");
    } catch (error) {
      console.error("Print error:", error);
      setStatus("Print failed");
    }
  };

  return (
    <div className="border p-4 rounded-lg">
      <h2 className="text-center">Printer</h2>

      <div
        className={cn({
          "text-center my-2 p-1 text-sm rounded-lg": true,
          "text-warning": true,
          "border border-warning": true,
          "text-success": status === "Connected",
          "text-error": status === "Disconnected",
          "border border-success": status === "Connected",
          "border border-error": status === "Disconnected",
        })}
      >
        {status}
      </div>
      <div className="flex justify-center items-center flex-col">
        <Button
          className="my-3 w-[150px]"
          onClick={status === "Connected" ? handleDisconnect : handleConnect}
        >
          {status === "Connected" ? "Disconnect Printer" : "Connect Printer"}
        </Button>

        <Button
          disabled={!writer || status === "Printing"}
          onClick={handlePrint}
          className="flex items-center gap-2 w-[150px]"
        >
          <Printer className="h-4 w-4" />
          Print Receipt
        </Button>
      </div>
    </div>
  );
};

export default OrderPrinterComponent;
